{
  "oneUpgrade": {
    "insufficientAviosPage": {
      "heading": "Liian vähän Avioksia tai korotusetuja",
      "notificationText": "Sinulla ei ole vielä tarpeeksi Avioksia tai korotusetuja liittyäksesi jonotuslistalle, mutta voit ostaa lisää Avioksia liittyäksesi siihen. Voit myös palata tarkistamaan 30 päivää ennen lähtöä, onko korotuksia ostettavissa rahalla.",
      "tableFlightsHeader": "Lennot",
      "tableRequiredAviosHeader": "Vaaditut Aviokset",
      "ctaLabel": "Osta lisää Avioksia",
      "ctaHref": "https://www.finnairshop.com/fi/buy-avios",
      "upgradeNotAvailable": "Korotuksia ei tarjolla"
    },
    "errorPageReturnButtonLabel": "Kokeile toista varausta"
  },
  "tripCard": {
    "bookingReferenceCopied": "Varaustunnus kopioitu leikepöydälle",
    "copyBookingReference": "Kopioi varaustunnus leikepöydälle"
  }
}
